import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=e7f96b4a&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=e7f96b4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7f96b4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e7f96b4a')) {
      api.createRecord('e7f96b4a', component.options)
    } else {
      api.reload('e7f96b4a', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=e7f96b4a&scoped=true&", function () {
      api.rerender('e7f96b4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2FabrPFTM6gCb/JS/comp/PopupDialog.vue"
export default component.exports